var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupUnlockedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 7.33464H4.50016V4.83464C4.50016 3.4563 5.62183 2.33464 7.00016 2.33464C8.3785 2.33464 9.50016 3.4563 9.50016 4.83464H11.1668C11.1668 2.53714 9.29766 0.667969 7.00016 0.667969C4.70266 0.667969 2.8335 2.53714 2.8335 4.83464V7.33464H2.00016C1.55814 7.33464 1.13421 7.51023 0.821651 7.82279C0.509091 8.13535 0.333496 8.55928 0.333496 9.0013V15.668C0.333496 16.11 0.509091 16.5339 0.821651 16.8465C1.13421 17.159 1.55814 17.3346 2.00016 17.3346H12.0002C12.4422 17.3346 12.8661 17.159 13.1787 16.8465C13.4912 16.5339 13.6668 16.11 13.6668 15.668V9.0013C13.6668 8.55928 13.4912 8.13535 13.1787 7.82279C12.8661 7.51023 12.4422 7.33464 12.0002 7.33464ZM5.38433 11.9171C5.48676 11.525 5.72844 11.1836 6.06423 10.9566C6.40001 10.7296 6.80694 10.6326 7.209 10.6838C7.61106 10.7349 7.98075 10.9307 8.24903 11.2345C8.51731 11.5383 8.66582 11.9293 8.66683 12.3346C8.66635 12.6261 8.58907 12.9123 8.44277 13.1643C8.29647 13.4164 8.08632 13.6255 7.8335 13.7705V15.668H6.16683V13.7705C5.85151 13.5898 5.6042 13.3106 5.46285 12.9758C5.32149 12.641 5.29391 12.2691 5.38433 11.9171Z",
    fill: "#2AA58E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupUnlockedIcon);
export default __webpack_public_path__ + "static/media/group_unlocked_icon.ee6812b466efd4ca97fcc562d6fb5345.svg";
export { ForwardRef as ReactComponent };